import uniq from 'lodash/uniq';

import { createSlice } from '@reduxjs/toolkit';

import { fetchTotalVendorsCount, postProjectVendorKeywordSuggestions } from './thunk';

export type VendorsState = {
    selected: Set<string>;
};

export const vendorsSlice = createSlice({
    name: 'vendors',
    initialState: {
        selected: [],
        status: 'idle',
        keywordSuggestions: [],
        totalVendorsCount: 0,
        error: null,
    },
    reducers: {
        selectVendors: (state, action) => {
            action.payload.forEach((vendorId) => state.selected.push(vendorId));
            state.selected = uniq(state.selected);
        },
        deselectVendors: (state, action) => {
            state.selected = state.selected.filter((id) => !action.payload.includes(id));
        },
        clearSelectedVendors: (state, action) => {
            state.selected = [];
        },
    },
    extraReducers(builder) {
        builder.addCase(fetchTotalVendorsCount.fulfilled, (state, action) => {
            state.totalVendorsCount = action.payload.count;
        });

        builder.addCase(postProjectVendorKeywordSuggestions.pending, (state) => {
            state.status = 'loading';
        });

        builder.addCase(postProjectVendorKeywordSuggestions.fulfilled, (state, action) => {
            state.keywordSuggestions = action.payload;
            state.status = 'succeeded';
        });
        builder.addCase(postProjectVendorKeywordSuggestions.rejected, (state, action) => {
            state.status = 'failed';
            state.error = action.error;
        });
    },
});

// Action creators are generated for each case reducer function
export const { selectVendors, deselectVendors, clearSelectedVendors } = vendorsSlice.actions;

export default vendorsSlice.reducer;
